import React from 'react';
import { COHORT_SEASONS } from '../../utils/calendar';
import { SegmentedControl } from '../ui/SegmentedControl';
import { PendingNote } from '../ui/PendingNote';
import { MetricInfoButton } from '../definitions/MetricInfoButton';
export type RetentionMode = 'season' | 'yoy';
export type YoyWindow = 'sameSeason' | 'within12';
interface RetentionControlsProps {
  mode: RetentionMode;
  onModeChange: (m: RetentionMode) => void;
  base: number;
  onBaseChange: (v: number) => void;
  comp: number;
  onCompChange: (v: number) => void;
  yoyWindow: YoyWindow;
  onYoyWindowChange: (w: YoyWindow) => void;
}
const selectClass = 'mt-1 h-9 w-full rounded-md border border-line bg-white px-2.5 text-[13px] font-medium text-ink focus:border-navy/50 focus:outline-none focus:ring-2 focus:ring-navy/15';
const seasonLabel = (idx: number) => `${COHORT_SEASONS[idx].label}${COHORT_SEASONS[idx].inProgress ? ' (in progress)' : ''}`;
export function RetentionControls(p: RetentionControlsProps) {
  const baseOptions = p.mode === 'season' ? COHORT_SEASONS.slice(0, -1) : COHORT_SEASONS.filter(s => s.idx + 4 < COHORT_SEASONS.length);
  const compOptions = COHORT_SEASONS.filter(s => s.idx > p.base);
  return <div className="rounded-lg border border-line bg-white px-5 py-4" data-id="element-447" data-mp="23dy91sgw4lnp">
      <div className="flex flex-wrap items-end gap-x-6 gap-y-4" data-id="element-448" data-mp="1ye3ijq111y36">
        <div data-id="element-449" data-mp="1yfwqr9ragqda">
          <div className="flex items-center gap-1.5" data-id="element-450" data-mp="1yg6eeqov2lft">
            <h2 className="text-[15px] font-semibold text-navy" data-id="element-451" data-mp="2v2t0thgkgspo">Season-Based Retention</h2>
            <MetricInfoButton id={p.mode === 'season' ? 'seasonRetention' : 'yoyRetention'} label="Season-Based Retention" data-id="element-452" data-mp="2r3k72clj0uu4" />
          </div>
          <div className="mt-2" data-id="element-453" data-mp="2m9oanekwvg12">
            <SegmentedControl ariaLabel="Retention type" value={p.mode} onChange={p.onModeChange} options={[{
            value: 'season',
            label: 'Season retention'
          }, {
            value: 'yoy',
            label: 'YOY retention'
          }]} data-id="element-454" data-mp="2hd7nonpg77pk" />
          </div>
        </div>

        <label className="w-48 text-xs font-medium text-ink-muted" data-id="element-455" data-mp="3sydrlhl7x6kd">
          Base season
          <select value={p.base} onChange={e => p.onBaseChange(Number(e.target.value))} className={selectClass} data-id="element-456" data-mp="1qsvz68kdfr5">
            {baseOptions.map(s => <option key={s.idx} value={s.idx} data-id="element-457" data-mp="3o6n9uqjybgix">{seasonLabel(s.idx)}</option>)}
          </select>
        </label>
        <span className="pb-2.5 text-ink-subtle" aria-hidden data-id="element-458" data-mp="3a62rfvhy7mpy">→</span>

        {p.mode === 'season' ? <label className="w-52 text-xs font-medium text-ink-muted" data-id="element-459" data-mp="3f709m82ykgrg">
            Comparison season
            <select value={p.comp} onChange={e => p.onCompChange(Number(e.target.value))} className={selectClass} data-id="element-460" data-mp="317r545o47b3b">
              {compOptions.map(s => <option key={s.idx} value={s.idx} data-id="element-461" data-mp="zfcemi7i8yba">{seasonLabel(s.idx)}</option>)}
            </select>
          </label> : <label className="w-64 text-xs font-medium text-ink-muted" data-id="element-462" data-mp="13g4o9ckah583">
            Comparison period
            <select value={p.yoyWindow} onChange={e => p.onYoyWindowChange(e.target.value as YoyWindow)} className={selectClass} data-id="element-463" data-mp="2nz8gics7twv3">
              <option value="sameSeason" data-id="element-464" data-mp="2jvai64apsq33">{seasonLabel(p.base + 4)} (same season, next year)</option>
              <option value="within12" data-id="element-465" data-mp="2xqcylld6txu5">Any program within 12 months</option>
            </select>
          </label>}

        <div className="ml-auto max-w-[360px] pb-1.5 text-[11.5px] leading-relaxed text-ink-muted" data-id="element-466" data-mp="37m6gzldl8lju">
          Uses the season and year of the <b className="text-ink" data-id="element-467" data-mp="32mtke8wx0042">registered program</b>, not the purchase date. Unique participants only. The acquisition date range does not apply here.
          <div className="mt-1.5" data-id="element-468" data-mp="3boj9v978koz7">
            <PendingNote data-id="element-469" data-mp="3bpclool1y4o7">Program season tagging & participant ID pending validation</PendingNote>
          </div>
        </div>
      </div>
    </div>;
}